import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  //FAQ
  FaqComponent,
  FaqListComponent,
  FaqRowComponent,

  //Dashboard
  DashboardComponent,

  //PayNCC
  PayNccComponent,
  PayComponent,
  PayServiceComponent,
  PayPaymentInstructionComponent,
  UploadProofOfPaymentComponent,

  //Sign-in
  SignInComponent,
  UserAccountComponent,

  //Contact
  ContactComponent,

  //Account
  Step3Component,
  SignUpComponent,
  Step2Component,
  Step1Component,
  AccountRowComponent,
  AccountInfoComponent,
  Step4Component,
  IdentificationComponent,
  LoginComponent,
  VerificationComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  InvitationComponent,
  EmailVerificationComponent,
  PrivacyComponent,
  ForeignDetailsComponent,
  PaymentInstructionComponent,
  PublicChatComponent,
  ChatMessagesComponent,
  CustomerTenderComponent,
  CustomerTenderListComponent,
  IRRStep2Component,
} from './components';
import { PublicComponent } from './contractor.component';

export const COMPONENTS: Array<any> = [
  //FAQ
  FaqComponent,
  FaqListComponent,
  FaqRowComponent,

  //Dashboard
  DashboardComponent,

  //PayNCC
  PayNccComponent,
  PayComponent,
  PayServiceComponent,
  PayPaymentInstructionComponent,
  UploadProofOfPaymentComponent,

  //Sign-in
  SignInComponent,
  UserAccountComponent,

  //Contact
  ContactComponent,
  PublicChatComponent,
  ChatMessagesComponent,

  //Account
  Step3Component,
  SignUpComponent,
  Step2Component,
  Step1Component,
  AccountRowComponent,
  AccountInfoComponent,
  Step4Component,
  IdentificationComponent,
  LoginComponent,
  VerificationComponent,
  ForgotPasswordComponent,
  ResetPasswordComponent,
  InvitationComponent,
  EmailVerificationComponent,
  PrivacyComponent,
  ForeignDetailsComponent,
  PaymentInstructionComponent,
  CustomerTenderComponent,
  CustomerTenderListComponent,
  IRRStep2Component,
];
const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    data: { title: 'NCC Eservices' },
    children: [
      {
        path: '',
        redirectTo: 'dashboard',
        // pathMatch: 'full'
      },
      {
        path: 'dashboard',
        data: { title: 'dashboard' },
        component: DashboardComponent,
      },
      {
        path: 'tender',
        data: { title: 'Customer Tender' },
        component: CustomerTenderComponent,
        children: [
          {
            path: '',
            redirectTo: 'list',
            data: { title: 'Customer Tender List' },
            // pathMatch: 'full'
          },
          {
            path: 'list',
            data: { title: 'Customer Tender List' },
            component: CustomerTenderListComponent,
          },
        ],
      },
      {
        path: 'terms-and-conditions',
        data: { title: 'terms and conditions' },
        component: PrivacyComponent,
      },
      {
        path: 'foreign-details',
        data: { title: 'foreign details' },
        component: ForeignDetailsComponent,
      },
      {
        path: 'payment-instruction',
        data: { title: 'payment instreuction' },
        component: PaymentInstructionComponent,
      },

      {
        path: 'faq',
        data: { title: 'faq' },
        component: FaqComponent,
        children: [
          {
            path: '',
            redirectTo: 'faq-list',
            // pathMatch: 'full'
          },
          {
            path: 'faq-list',
            component: FaqListComponent,
          },
        ],
      },
      {
        path: 'pay',
        component: PayComponent,
        children: [
          {
            path: '',
            redirectTo: 'payNCC',
            // pathMatch: 'full'
          },
          {
            path: 'foreign-payment/upload-proof-of-payment',
            data: { title: 'foreign payment' },
            component: UploadProofOfPaymentComponent,
          },

          {
            path: 'payNCC',
            data: { title: 'pay NCC' },
            component: PayNccComponent,
          },
          {
            path: 'pay-service/:id',
            data: { title: 'pay service' },
            component: PayServiceComponent,
          },
          {
            path: 'pay-service',
            data: { title: 'pay service' },
            component: PayServiceComponent,
          },
          {
            path: 'instruction',
            data: { title: 'instruction' },
            component: PayPaymentInstructionComponent,
          },
        ],
      },

      //Sign-in
      {
        path: 'sign-in',
        data: { title: 'sign in' },
        component: SignInComponent,
      },
      {
        path: 'user-account',
        data: { title: 'user account' },
        component: UserAccountComponent,
      },
      {
        path: 'invitation',
        data: { title: 'invitation' },
        component: InvitationComponent,
      },
      {
        path: 'email-verification',
        data: { title: 'email verification' },
        component: EmailVerificationComponent,
      },

      //Contact
      {
        path: 'contact',
        data: { title: 'contact' },
        component: ContactComponent,
      },
      {
        path: 'chat/:id',
        data: { title: 'chat' },
        component: PublicChatComponent,
      },
      {
        path: 'forgot-password',
        data: { title: 'forgot password' },
        component: ForgotPasswordComponent,
      },
      {
        path: 'reset-password',
        data: { title: 'reset password' },
        component: ResetPasswordComponent,
      },

      {
        path: 'sign-up',
        data: { title: 'sign up' },
        component: SignUpComponent,
        children: [
          {
            path: '',
            redirectTo: 'step1',
            // pathMatch: 'full'
          },
          {
            path: 'step1',
            data: { title: 'step 1' },
            component: Step1Component,
          },
          {
            path: 'step2',
            data: { title: 'step 2' },
            component: Step2Component,
          },
          {
            path: 'irr-step2',
            data: { title: 'irrstep 2' },
            component: IRRStep2Component,
          },
          {
            path: 'step3',
            data: { title: 'step 3' },
            component: Step3Component,
          },
          {
            path: 'step4',
            data: { title: 'step 4' },
            component: LoginComponent,
          },
          {
            path: 'step5',
            data: { title: 'step 5' },
            component: AccountInfoComponent,
          },
          {
            path: 'identification',
            data: { title: 'identification' },
            component: IdentificationComponent,
          },
          {
            path: 'login',
            data: { title: 'login' },
            component: LoginComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class ContractorRoutingModule {}
